import React from 'react';
import { Label, UncontrolledTooltip } from "reactstrap";

class LabelWithToolTip extends React.PureComponent<{ label: string, tooltip: string, field: string, className?: string }>
{
    public render() {
        const {field, label, tooltip} = this.props;

        return <Label className={this.props.className || 'form-label'} for={field}>
            {label}

            {tooltip && <>
                <i className="mdi mdi-information" id={`info_${field}`}></i>
                <UncontrolledTooltip placement="bottom" target={`info_${field}`} className="fno-tooltip-container">
                    {tooltip}
                </UncontrolledTooltip>
            </>}
        </Label>;
    }
}

export default LabelWithToolTip;